function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#4CC97D",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 10.5,
  r: 10.5,
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7.537 11.194l2.642 3.633 5.284-6.274"
}));

function SvgGreenV(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg width='23' height='23' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%234CC97D' fill='none' fill-rule='evenodd'%3E%3Ccircle cx='10.5' cy='10.5' r='10.5' transform='translate(1 1)'/%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M7.537 11.194l2.642 3.633 5.284-6.274'/%3E%3C/g%3E%3C/svg%3E";
export { SvgGreenV as ReactComponent };